import EmailSignupForm from "@/components/EmailSignupForm";

export default function FinalCTA() {
  return (
    <section
      id="final-cta"
      data-testid="final-cta"
      className="bg-[#1A1A1A] text-[#F7F5F2] relative overflow-hidden"
    >
      {/* Soft celestial mark */}
      <div aria-hidden="true" className="absolute top-12 right-12 opacity-25 hidden md:block">
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
          <circle cx="60" cy="60" r="40" stroke="#F7F5F2" strokeWidth="0.6" strokeDasharray="1.4 4" />
          <circle cx="60" cy="60" r="22" stroke="#F7F5F2" strokeWidth="0.5" />
          <circle cx="60" cy="60" r="2" fill="#1FA5B8" />
          {[...Array(12)].map((_, i) => {
            const a = (i * 30 * Math.PI) / 180;
            return (
              <line
                key={i}
                x1={60 + Math.cos(a) * 50}
                y1={60 + Math.sin(a) * 50}
                x2={60 + Math.cos(a) * 56}
                y2={60 + Math.sin(a) * 56}
                stroke="#F7F5F2"
                strokeWidth="0.6"
              />
            );
          })}
        </svg>
      </div>

      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32 relative">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 md:col-span-8" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#F7F5F2]/60 font-body">
              A doorway, not a destination
            </div>
            <h2 className="mt-4 font-display leading-[0.98] tracking-tight text-[clamp(2.75rem,6vw,5rem)] font-medium">
              The work, your{" "}
              <span className="italic font-light">real</span> work, has been
              waiting for you.
            </h2>
            <p className="mt-6 font-body text-[#F7F5F2]/70 text-lg leading-relaxed max-w-xl">
              You don&apos;t have to know what it is yet. You only have to be
              willing to listen for it. The reawakening begins quietly, and
              this is the smallest possible way in.
            </p>
          </div>

          <div className="col-span-12 md:col-span-4" data-reveal>
            <p className="font-body text-sm text-[#F7F5F2]/70 mb-5 leading-relaxed">
              A free PDF guide called{" "}
              <span className="font-display italic text-[#F7F5F2]">
                The 5 Minute Creative Reactivation Formula
              </span>
              . Sent to your inbox in the next minute.
            </p>
            <EmailSignupForm
              source="final_cta"
              testIdPrefix="final"
              dark
              redirectTo="/the-deeper-reactivation"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
